"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormCredit = void 0;
var react_1 = __importStar(require("react"));
var FormCredit_module_scss_1 = __importDefault(require("./FormCredit.module.scss"));
var SelectAutoButton_1 = require("../selectAutoButton/SelectAutoButton");
var FieldSlider_1 = require("../fieldSlider/FieldSlider");
var FormField_1 = require("../formField/FormField");
var FormFieldPhone_1 = require("../formFieldPhone/FormFieldPhone");
var Checkbox_1 = require("../checkbox/Checkbox");
var CheckboxAgree_1 = require("../checkboxAgree/CheckboxAgree");
var FormSendButton_1 = require("../formSendButton/FormSendButton");
var react_redux_1 = require("react-redux");
var selectors_1 = require("../../redux/selectors");
var react_google_recaptcha_1 = __importDefault(require("react-google-recaptcha"));
var FormCredit = function (props) {
    var _a;
    var register = props.register, errors = props.errors, onSubmit = props.onSubmit, handleSubmit = props.handleSubmit, sliderField = props.sliderField, setValue = props.setValue, payment = props.payment;
    var stateModalCredit = (0, react_redux_1.useSelector)(selectors_1.modalSelector).credit.modalState;
    var _b = (0, react_1.useState)(null), captchaToken = _b[0], setCaptchaToken = _b[1];
    // Определяем, нужна ли капча
    var isCaptchaEnabled = process.env.CAPTCHA_ENABLED === 'true';
    var handleFormSubmit = function (data) {
        if (isCaptchaEnabled && !captchaToken) {
            alert('Пожалуйста, подтвердите, что вы не робот.');
            return;
        }
        onSubmit(__assign(__assign({}, data), { captcha_token: captchaToken }));
    };
    return (react_1.default.createElement("form", { className: FormCredit_module_scss_1.default.form_credit, onSubmit: handleSubmit(handleFormSubmit) },
        !stateModalCredit ? (react_1.default.createElement(SelectAutoButton_1.SelectAutoButton, { isError: Boolean(errors.car_id), register: register('car_id', {
                required: true,
                validate: function (value) { return String(value) !== 'Выбрать автомобиль'; },
            }) })) : null,
        react_1.default.createElement(FieldSlider_1.FieldSlider, { endpoints: sliderField.endpoints.credit_terms, initValue: 2, register: register('credit_term', { required: true }), steps: sliderField.steps.credit_terms, ticksContentWidth: 'calc(100% - 23px)', ticksLeft: "17px", titleText: "\u0421\u0440\u043E\u043A \u043A\u0440\u0435\u0434\u0438\u0442\u0430, \u043C\u0435\u0441.:", unitOfMeasurement: "\u043C\u0435\u0441.", setValue: setValue, fieldName: 'credit_term' }),
        react_1.default.createElement(FieldSlider_1.FieldSlider, { endpoints: sliderField.endpoints.initial_contribution, initValue: 0, register: register('initial_contribution', { required: true }), steps: sliderField.steps.initial_contribution, ticksContentWidth: 'calc(100% - 10px)', ticksLeft: "15px", titleText: "\u041F\u0435\u0440\u0432\u043E\u043D\u0430\u0447\u0430\u043B\u044C\u043D\u044B\u0439 \u0432\u0437\u043D\u043E\u0441:", unitOfMeasurement: "\u20BD", setValue: setValue, fieldName: 'initial_contribution', unitTicks: '%' }),
        react_1.default.createElement("h3", { className: FormCredit_module_scss_1.default.form_credit__payment },
            "\u0412\u0430\u0448 \u043F\u043B\u0430\u0442\u0451\u0436:",
            react_1.default.createElement("span", null,
                payment,
                "\u20BD")),
        react_1.default.createElement(FormField_1.FormField, { id: "installment_your_name", placeholder: "\u0424\u0418\u041E", register: register('name', {
                required: true,
                minLength: {
                    value: 2,
                    message: 'Минимальная длина - 2 символа.',
                },
                pattern: {
                    value: /^[a-zA-Zа-яА-ЯёЁ\s-]+$/,
                    message: 'Используйте только буквы, пробел или дефис',
                },
            }), isError: Boolean(errors.name) }),
        react_1.default.createElement(FormFieldPhone_1.FormFieldPhone, { id: "installment_credit_phone", isError: Boolean(errors.phone), register: register }),
        react_1.default.createElement(Checkbox_1.Checkbox, { id: "installment_agree_country", isError: Boolean(errors.agree_country), register: register('agree_country', { required: true }), textContent: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u044E \u043D\u0430\u043B\u0438\u0447\u0438\u0435 \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u0442\u0432\u0430 \u0420\u0424" }),
        react_1.default.createElement(CheckboxAgree_1.CheckboxAgree, { id: "installment_agree", isError: Boolean(errors.agree), register: register('agree', { required: true }) }),
        isCaptchaEnabled && (react_1.default.createElement(react_google_recaptcha_1.default, { sitekey: (_a = process.env.REACT_APP_RECAPTCHA_SITE_KEY) !== null && _a !== void 0 ? _a : '', onChange: function (token) { return setCaptchaToken(token); } })),
        react_1.default.createElement(FormSendButton_1.FormSendButton, { textContent: "\u041E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443" })));
};
exports.FormCredit = FormCredit;
